module.exports = __webpack_public_path__ + "assets/img/30_711_big.35bca281.jpg";